import React, {useContext, useEffect, useState} from "react";
import {Button, Space, Typography} from "@bezlimit/bezlimit-ui";
import {useTranslation} from "react-i18next";
import "./style.scss";
// core
import {IPhone} from "../../../../../../core/models/Phones";
import {IPhonesFiltersRequest} from "../../../../../../core/models/PhonesFilters";
// components
import Phone from "./phone";
import Description from "./description";
import {LayoutContext, ModalContext} from "../../../../../../core/Contexts";
import BookANumberTurbo from "../../../../../modal/bookANumberTurbo";
import Success from "../../../../../modal/success";
import Error from "../../../../../modal/error";
import _ from "lodash";
// services
import PhoneService from "../../../../../../services/PhoneService";
import PhonesDefaultService from "../../../../../../services/PhonesDefaultService";
import ReservationsService from "../../../../../../services/ReservationsService";
import PhonesFiltersService from "../../../../../../services/PhonesFiltersService";
import UserService from "../../../../../../services/UserService";
import ButtonChatSupport from "../../../../delivery/buttonChatSupport";
import ListTariffService from "./listTariffService";

export default React.memo(function Info({Service, filters, gridType, props}: IProps) {
    const {
        phone,
        type,
        mask: {category},
        tariff: {id, name: tariffName, minutes, internet, sms},
        region: {name: regionName}
    } = props;
    const contextModal = useContext(ModalContext);
    const {t} = useTranslation();
    const [state, setState] = useState<string>("3 часа");
    const contextLayout = useContext(LayoutContext);

    const onClickWhatsApp = () => {
        (
            window.open(`https://wa.me/7${UserService.personalManager.phone}`, "_blank") as any
        ).focus();
    };

    const onClick = async () => {
        const storage = localStorage.getItem("understand");

        if (storage) {
            try {
                const filter =
                localStorage.getItem("isFavorite") === "collection"
                    ? "collection"
                    : localStorage.getItem("isFavorite") === 'true'
                    ? "favorite"
                    : "professional";
                    
                await ReservationsService.postReservationTurbo({
                    phone: phone.toString(),
                    loading: true,
                    additional_data: JSON.stringify({
                        source: "store_web",
                        filter,
                    })
                });
                contextModal?.setChildren(
                    <Success
                        title={
                            <Typography as="span">
                                {t("Номер успешно")}
                                <br />
                                {t("забронирован")}
                            </Typography>
                        }
                        subtitle={
                            <Typography as="span">
                                {t("Номер забронирован на {days},", {days: state})}
                                <br />
                                {t("вы можете просмотреть его на странице")}
                                <br />
                                {t("“Мои брони”")}
                            </Typography>
                        }
                    />
                );
                Service.updatePhones(PhonesFiltersService.getFormatedFilters(filters));
            } catch (e: any) {
                if (_.isEqual(e.response.status, 430)) {
                    contextModal?.setChildren(
                        <Error
                            title="Вы превысили лимит"
                            message={
                                <Space size={16} direction="vertical">
                                    {_.isEqual(UserService.level.level, 0) ? (
                                        <>
                                            <Typography as="div" size={14} color="#000000">
                                                {t("Повторите попытку завтра.")}
                                                <br />
                                                {t("Чтобы увеличить лимит обратитесь в чат")}
                                            </Typography>
                                            <ButtonChatSupport
                                                type="primary"
                                                text="Написать в чат"
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <Typography as="div" size={14} color="#000000">
                                                {t(
                                                    "Повторите попытку завтра. Чтобы увеличить лимит"
                                                )}
                                                <br />
                                                {t("обратитесь к персональному менеджеру")}
                                            </Typography>
                                            <Button onClick={onClickWhatsApp} type="primary">
                                                {t("Написать в WhatsApp")}
                                            </Button>
                                        </>
                                    )}
                                </Space>
                            }
                        />
                    );
                } else {
                    contextModal?.setChildren(<Error />);
                }
            }
        } else {
            contextModal?.setChildren(
                <BookANumberTurbo phone={phone} type={type} filters={filters} Service={Service} />
            );
        }
        contextModal?.setVisible(true);
    };

    useEffect(() => {
        let name: string;

        switch (type) {
            case 4:
                name = "1 день";
                break;
            case 5:
                name = "5 дней";
                break;
            default:
                name = "3 часа";
                break;
        }

        setState(name);
    }, [type]);

    return (
        <Typography as="div" className="bl-numbers-list-info">
            {_.isEqual(gridType, "kanban") && _.gte(contextLayout?.width, 768) ? (
                <Space size={16}>
                    <Phone category={category} phone={phone} />
                    <Description
                        type={type}
                        phone={phone}
                        category={category}
                        tariffName={tariffName}
                        regionName={regionName}
                        minutes={minutes}
                        internet={internet}
                        sms={sms}
                        id={id}
                        filters={filters}
                        Service={Service}
                    />
                    {!PhonesDefaultService.isPaid(type) && (
                        <div className="gold-bg icon-wrapper lightning" onClick={onClick}>
                            <svg className="lightning" width="32" height="32">
                                <use href={"#lightning1"} />
                            </svg>
                        </div>
                    )}
                </Space>
            ) : (
                <ListTariffService
                    filters={filters}
                    Service={Service}
                    props={props}
                    onClick={onClick}
                />
            )}
        </Typography>
    );
});

interface IProps {
    filters: IPhonesFiltersRequest;
    props: IPhone;
    Service: PhoneService;
    gridType: string;
}
